// removed by extract-text-webpack-plugin
module.exports = {"page":"_2i-qV3Kr5UM97dWv1OT4u1"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/containers/Page.css
// module id = 210
// module chunks = 0